import { render } from "./levelSelector.vue?vue&type=template&id=2994922d&ts=true"
import script from "./levelSelector.vue?vue&type=script&lang=ts"
export * from "./levelSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__